import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Box from '../../elements/Box';
import Text from '../../elements/Text';

import Icon from '../../elements/Icon';

const Loading = (props) => {
  const {
    showIcon = false,
    showDescription = false,
    showLoader = false,
    labelKey = 'cmp-loading-fares',
    messageKey = 'cmp-loading-message-description',
    isLoading = true,
    iconSettings = { icon: 'spinner', fontSize: '8', display: 'inline-block' },
    loaderSettings = {},
    spinnerContainer = {},
    textSettings = {},
    enableAccessibilityMessage = false
  } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  //TODO: This causes that scrolling on the map is not allowed
  // const newStyle = {
  //   ...style,
  //   touchAction: 'none'
  // };
  return (
    <div
      className={`${className} spinner-loading`}
      style={style}
      role={enableAccessibilityMessage ? null : isLoading ? 'alert' : null}
      data-testid="loading"
      aria-label={isLoading ? translate(labelKey, 'Content is loading...') : null}
    >
      {showIcon && (
        <Box {...spinnerContainer} className="icon-spinner-container">
          <Icon {...iconSettings} />
          {showLoader && <Box {...loaderSettings} className="fr-loader" />}
          {showDescription && (
            <Text {...textSettings} aria-hidden={enableAccessibilityMessage ? true : false}>
              {translate(messageKey, 'Please wait while we load the best fares for you')}
            </Text>
          )}
        </Box>
      )}
    </div>
  );
};

Loading.propTypes = {
  /**
   * Show component icon
   */
  showIcon: PropTypes.bool,
  /**
   * label key props
   */
  labelKey: PropTypes.string,
  /**
   * It determines if the alert is
   * going to be assertive so that
   * for accessibility the SR reads
   * it, this prop is added because
   * in the map this alert is used
   * as a decorative element
   */
  isLoading: PropTypes.bool
};

Loading.componentName = 'Loading';

export default Loading;
